<template>
  <div>
    <div class="toolbar">
      <el-input v-model="search" placeholder="输入关键字搜索" style="width:400px;margin-left:8px;margin-right:8px;" clearable/>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      @sort-change="handleSort"
    >
      <el-table-column prop="id" label="编号" sortable="custom" width="100"></el-table-column>
      <el-table-column label="预览">
        <template v-slot="column">
          <PinyinPreview class="pinyin-preview" :text="column.row.text" :pinyin="column.row.pinyin"></PinyinPreview>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click="handleSelect(scope.row)" type="text" size="small">添加</el-button>
          <el-button @click="handleSelectExercise(scope.row)" type="text" size="small">自动出题</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-if="total>pageSize"
    >
    </el-pagination>
  </div>
</template>

<script>
import table from '@/components/mixins/table.js'
import PinyinPreview from '@/components/PinyinPreview'

export default {
  name: 'SentenceList',
  mixins:[table],
  data () {
    return {
      dialogTitle: '添加句子',
      dialogVisible: false,
      batchVisible: false,
      fetchUrl: 'sentence_list',
      search: '',
      searchType: null,
      showWordDialog: false,
      showWordModel: null
    }
  },
  components: { PinyinPreview },
  watch: {
    search () {
      this.fetchData()
    },
    searchType () {
      this.fetchData()
    },
  },
  methods: {
    handleFetchConfig (config) {
      if (this.search || this.searchType) {
        Object.assign(config.params, {
          "filter[status]": null,
          "filter[and][0][status]": 1,
          "filter[and][0][ref_type]": this.searchType || null,
          "filter[and][1][or][0][text][like]": this.search || null,
          "filter[and][1][or][1][pinyin][like]": this.search || null
        })
      }
    },
    handleSelect (val) {
      this.$emit('change', {
        type: 'sentence',
        entity: val
      })
    },
    handleSelectExercise (val) {
      this.$emit('change', {
        type: 'iq_sentence',
        entity: val
      })
    },
    tabactivated() {
      this.tabdeactive = false
      if (this.filterChanged) {
        this.fetchData()
      }
    },
    tabdeactivated() {
      this.tabdeactive = true
    },
    fetchData() {
      if (this.tabdeactive) {
        this.filterChanged = true
        return
      }
      this.filterChanged = false
      this.fetchDataInternal()
    }
  }
}
</script>